import { render, staticRenderFns } from "./EventMonth.vue?vue&type=template&id=21a67a15&scoped=true&"
import script from "./EventMonth.vue?vue&type=script&lang=js&"
export * from "./EventMonth.vue?vue&type=script&lang=js&"
import style0 from "./EventMonth.vue?vue&type=style&index=0&id=21a67a15&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a67a15",
  null
  
)

export default component.exports